export default "__VITE_ASSET__5tQ9ZkQg__"